import {
    CREATE_AGGREGATION_OPERATION,
    CREATE_BLEND_OPERATION,
    CREATE_FILTER_OPERATION,
    CREATE_FORMULA_OPERATION,
    CREATE_PIVOT_OPERATION,
    CREATE_PROJECTION_OPERATION,
    CREATE_REPLACE_OPERATION,
    CREATE_SPLIT_OPERATION,
    CREATE_SUBSTRING_EXTRACT_OPERATION,
    UPDATE_AGGREGATION_OPERATION,
    UPDATE_BLEND_OPERATION,
    UPDATE_FILTER_OPERATION,
    UPDATE_FORMULA_OPERATION,
    UPDATE_PIVOT_OPERATION,
    UPDATE_PROJECTION_OPERATION,
    UPDATE_REPLACE_OPERATION,
    UPDATE_SPLIT_OPERATION,
    UPDATE_SUBSTRING_EXTRACT_OPERATION
} from 'app/store/__generated__/operations';
import { TransformationType } from 'app/lib/types/server';

export function getCreateCommand(operation) {
    switch (operation) {
        case TransformationType.AGGREGATION:
            return CREATE_AGGREGATION_OPERATION;
        case TransformationType.EXTRACT:
            return CREATE_SUBSTRING_EXTRACT_OPERATION;
        case TransformationType.FILTER:
            return CREATE_FILTER_OPERATION;
        case TransformationType.FORMULA:
            return CREATE_FORMULA_OPERATION;
        case TransformationType.LEGACY_JOIN:
            return CREATE_BLEND_OPERATION;
        case TransformationType.LEGACY_PROJECTION:
            return CREATE_PROJECTION_OPERATION;
        case TransformationType.PIVOT:
            return CREATE_PIVOT_OPERATION;
        case TransformationType.REPLACE:
            return CREATE_REPLACE_OPERATION;
        case TransformationType.SPLIT:
            return CREATE_SPLIT_OPERATION;
        default:
            throw new Error(`Create Command for ${operation} not found.`);
    }
}

export function getUpdateCommand(operation) {
    switch (operation) {
        case TransformationType.AGGREGATION:
            return UPDATE_AGGREGATION_OPERATION;
        case TransformationType.EXTRACT:
            return UPDATE_SUBSTRING_EXTRACT_OPERATION;
        case TransformationType.FILTER:
            return UPDATE_FILTER_OPERATION;
        case TransformationType.FORMULA:
            return UPDATE_FORMULA_OPERATION;
        case TransformationType.LEGACY_JOIN:
            return UPDATE_BLEND_OPERATION;
        case TransformationType.LEGACY_PROJECTION:
            return UPDATE_PROJECTION_OPERATION;
        case TransformationType.PIVOT:
            return UPDATE_PIVOT_OPERATION;
        case TransformationType.REPLACE:
            return UPDATE_REPLACE_OPERATION;
        case TransformationType.SPLIT:
            return UPDATE_SPLIT_OPERATION;
        default:
            throw new Error(`Update Command for ${operation} not found.`);
    }
}
